import {
    UPDATE_POST_COUNTS_AFTER_SARCASM_TOGGLED
} from './constants';
import {
    getThreeClassSentimentCategory
} from '../../shared-components/chart/redux/updateChartForRelevanceUpdatesOfCommentOrTweetService';
import { SARCASM_THRESHOLD } from '../../../common/globalConstants';

const CATEGORY_KEY                    = "category";
const TOTAL_KEY                       = "total";
const SCORE_KEY                       = "score";
const IS_SARCASM_MANUALLY_TOGGLED_KEY = "isSarcasmManuallyToggled";

export function updatePostCountsForToggledSarcasticComment(feedId,commentAfterToggling,emotionCategoryBeforeTogglingComment,sentimentCategoryBeforeTogglingComment) {
    return dispatch => {
        dispatch({
            type: UPDATE_POST_COUNTS_AFTER_SARCASM_TOGGLED,
            data: {
                feedId: feedId,
                commentAfterToggling: commentAfterToggling,
                emotionCategoryBeforeTogglingComment: emotionCategoryBeforeTogglingComment,
                sentimentCategoryBeforeTogglingComment: sentimentCategoryBeforeTogglingComment
            }
        });
    };
}

export function reducer(state, action) {
    if (action.type !== UPDATE_POST_COUNTS_AFTER_SARCASM_TOGGLED) {
        return state;
    }
    if (!state) {
        return state;
    }
    const {
        feedId,
        commentAfterToggling,
        emotionCategoryBeforeTogglingComment,
        sentimentCategoryBeforeTogglingComment
    } = action.data;
    if (!commentAfterToggling.relevance) {
        return state;
    }
    const emotionCategoryAfterTogglingComment   = commentAfterToggling.emotion.category;
    const sentimentCategoryAfterTogglingComment = commentAfterToggling.sentiment.category;
    
    const threeClassSentimentCategoryBeforeToggling = getThreeClassSentimentCategory(sentimentCategoryBeforeTogglingComment);
    const threeClassSentimentCategoryAfterToggling  = getThreeClassSentimentCategory(sentimentCategoryAfterTogglingComment);

    const updatedFeeds = state.allFeeds.data.map(feed => {
        if (feed.feedId === String(feedId)) {
            feed = updatePostSentimentCounts(
                feed,
                threeClassSentimentCategoryBeforeToggling,
                threeClassSentimentCategoryAfterToggling
            );
            feed = updatePostEmotionCounts(
                feed,
                emotionCategoryBeforeTogglingComment,
                emotionCategoryAfterTogglingComment
            );
            feed = updatePostSarcasticCommentCount(
                feed,
                commentAfterToggling
            );
        }
        return feed;
    });
    state.allFeeds.data = updatedFeeds;

    state = updateFeedModalFilteredCommentCounts(
        state,
        commentAfterToggling,
        threeClassSentimentCategoryBeforeToggling,
        emotionCategoryBeforeTogglingComment,
        threeClassSentimentCategoryAfterToggling,
        emotionCategoryAfterTogglingComment
    );
    return state;
}

export function updatePostSentimentCounts(
    feed,
    threeClassSentimentCategoryBeforeToggling,
    threeClassSentimentCategoryAfterToggling
) {
    if (threeClassSentimentCategoryBeforeToggling === threeClassSentimentCategoryAfterToggling) {
        return feed;
    }
    const newSentimentCounts = [...feed.sentiment]
    for (const sentiment of newSentimentCounts) {
        if (sentiment[CATEGORY_KEY] === threeClassSentimentCategoryBeforeToggling) {
            sentiment[TOTAL_KEY] -= 1;
        }
        else if (sentiment[CATEGORY_KEY] === threeClassSentimentCategoryAfterToggling) {
            sentiment[TOTAL_KEY] += 1;
        }
    }
    feed.sentiment = newSentimentCounts;
    return feed;
}

export function updatePostEmotionCounts(
    feed,
    emotionCategoryBeforeTogglingComment,
    emotionCategoryAfterTogglingComment
) {
    if (emotionCategoryBeforeTogglingComment === emotionCategoryAfterTogglingComment) {
        return feed;
    }
    const newEmotionCounts = {...feed.emotionCounts}
    for (const emotion of Object.keys(newEmotionCounts)) {
        if (emotion === emotionCategoryBeforeTogglingComment) {
            newEmotionCounts[emotion] -= 1;
        }
        else if (emotion === emotionCategoryAfterTogglingComment) {
            newEmotionCounts[emotion] += 1;
        }
    }
    feed.emotionCounts = newEmotionCounts;
    return feed;
}

export function updatePostSarcasticCommentCount(
    feed,
    commentAfterToggling
) {
    if (commentAfterToggling.sarcasm[SCORE_KEY] < SARCASM_THRESHOLD) {
        if (commentAfterToggling.sarcasm[IS_SARCASM_MANUALLY_TOGGLED_KEY]) {
            feed.sarcasticCommentCount += 1;
        }
        else {
            feed.sarcasticCommentCount -= 1;
        }
      }
      else if (commentAfterToggling.sarcasm[SCORE_KEY] >= SARCASM_THRESHOLD) {
        if (commentAfterToggling.sarcasm[IS_SARCASM_MANUALLY_TOGGLED_KEY]) {
            feed.sarcasticCommentCount -= 1;
        }
        else {
            feed.sarcasticCommentCount += 1;
        }
    }
    return feed;
}

export function updateFeedModalFilteredCommentCounts(
    state,
    commentAfterToggling,
    threeClassSentimentCategoryBeforeToggling,
    emotionCategoryBeforeTogglingComment,
    threeClassSentimentCategoryAfterToggling,
    emotionCategoryAfterTogglingComment
) {
    if (isCommentInFeedModal(state, commentAfterToggling) && state.feedDetails.filteredCommentCounts) {
        const newFilteredCommentCounts = {...state.feedDetails.filteredCommentCounts}
        newFilteredCommentCounts[threeClassSentimentCategoryBeforeToggling] -= 1;
        newFilteredCommentCounts[emotionCategoryBeforeTogglingComment] -= 1;

        newFilteredCommentCounts[threeClassSentimentCategoryAfterToggling] += 1;
        newFilteredCommentCounts[emotionCategoryAfterTogglingComment] += 1;
        state.feedDetails.filteredCommentCounts = newFilteredCommentCounts;
    }
    return state;
}

export function isCommentInFeedModal(state, commentAfterToggling) {
    if (!state.feedDetails.data || state.feedDetails.data.length === 0) {
        return false;
    }
    for (let key in state.feedDetails.data) {
        if (state.feedDetails.data[key].commentId === commentAfterToggling.commentId) {
            return true;
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/features/home/redux/updatePostCountsForToggledSarcasticComment.js